import { setNotificationAtom } from "atoms";
import { useSetAtom } from "jotai";
import { useTranslation } from "react-i18next";

interface DownloadHelper {
  notifyDownloadResult: (isSuccessful: boolean) => void;
}

export function useDownload(): DownloadHelper {
  const { t } = useTranslation();
  const setNotification = useSetAtom(setNotificationAtom);

  const notifyDownloadResult = (isSuccessful: boolean) => {
    if (!isSuccessful) {
      setNotification({
        message: t("notifications.downloadFailure"),
        severity: "error",
      });
    }
  };

  return { notifyDownloadResult };
}
